"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUpdate = void 0;
const react_1 = require("react");
const updateReducer = (num) => (num + 1) % 1000000;
/**
 * React utility hook that returns a function that forces component to re-render when called.
 *
 */
function useUpdate() {
    const [, update] = (0, react_1.useReducer)(updateReducer, 0);
    return update;
}
exports.useUpdate = useUpdate;
//# sourceMappingURL=use-update.js.map